import {faPlus} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import {forwardRef} from '@chakra-ui/react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconButton} from './IconButton';
import type {UIIconButtonProps} from './typings';

export const AddIconButton = forwardRef<UIIconButtonProps, 'button'>((props, ref) => (
  <IconButton size={`xs`} aria-label={`Add`} isRound icon={<FontAwesomeIcon icon={faPlus} />} {...props} ref={ref} />
));
